export const SUBSTITUTABLE_REPORT_KEYWORDS = ['reporte', 'report'];

export const DEFAULT_REPORT_TAG = `[[${SUBSTITUTABLE_REPORT_KEYWORDS[0]}]]`;

const reportTagAlternation = SUBSTITUTABLE_REPORT_KEYWORDS.map(
  (keyword) => `\\[\\[${keyword}\\]\\]`
).join('|');

export const REPORT_TAG_REGEX = new RegExp(reportTagAlternation, 'gi');

const ONLY_REPORT_TAG_REGEX = new RegExp(
  `^\\s*(?:${reportTagAlternation})\\s*$`,
  'i'
);

export const isOnlyReportTag = (bodyTemplate) =>
  ONLY_REPORT_TAG_REGEX.test(bodyTemplate ?? '');

export const hasReportPreview = (bodyTemplate, text) =>
  Boolean(text || !isOnlyReportTag(bodyTemplate));

export const replaceReportTag = (bodyTemplate, text) =>
  (bodyTemplate ?? '').replace(REPORT_TAG_REGEX, text ?? '');
